import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import moment from "moment";

import "../index.css"

import { TabView, TabPanel } from 'primereact/tabview';
import { Checkbox } from "primereact/checkbox";
import { FileUpload } from 'primereact/fileupload';
import { Dialog } from "primereact/dialog";

import { Button, CalendarField, TextInputField, DropDownField, CheckboxField } from "../../../helpers"

import Loading from "../../../common/Loading";
import BillingAddressCards from "../../../common/BillingAddressCards";
import CopyToClipboard from "../../../common/CopyToClipboard";

import PIReceivedProductDetails from "./PIReceivedProductDetails";
import GRN from "../../Warehouse/Dispatch/Components/GRN";
import PIPunchConfirmDialog from "./PIPunchConfirmDialog";

import { getSellerPOBySellerPOId, insertPIPunch } from "../../../services/api/sellerPO";
import { deleteSellerPIPunch, getTotalCompanyAmountByCompanyId, updateSellerPIPunch } from "../../../services/api/sellerPIPunch";
import { getCompanyById, uploadFile } from "../../../services/api/company";
import { getMaterialItemsDataByBuyerReqItemIds } from "../../../services/api/buyerReqItem";
import { getCompanyBillAddrs } from "../../../services/api/companyBillAddr";
import { getPOPunchItemByBuyerPOIds } from "../../../services/api/poPunchItem";
import { getMaterialMasterAndTempMaterialIds } from "../../../services/api/materialMaster";
import { getUsers } from "../../../services/api/user";
import { getAdjustmentNotesBySellerPIPunchIds } from "../../../services/api/adjustmentNotes";
import { getApprovalInstancesByDocNos } from "../../../services/api/approvalInstances";
import { getVendorPaymentBySellerPOId } from "../../../services/api/vendorPayment";
import { getStatesData } from "../../../services/api/state";

import { setSelectedSellerPO } from "../../../services/redux/reducers/Requirement/requirement";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { fetchStates, fetchTDSSections, fetchHSNMasterData, fetchMaterialBrands, fetchTicketSubCategory, fetchApprovals } from "../../../services/redux/reducers/commonThunk";

import { calculateSellerPI, getDateString, validateInputs, numberConversion, getUOMStr, round, getUploadedFileObj } from "../../../utils";

import { piPunchSchema } from "../../../validation/sellerPIPunch";
import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";
import { DATE_FORMAT } from "../../../constants";
import Tooltip from "../../../helpers/Tooltip";


const PIPunch = (props) => {
    const { sellerPOId } = props

    let [piPunchImageName, setPIPunchImageName] = useState(null)

    const [piPunchErrors, setPIPunchErrors] = useState({})
    const [checked, setChecked] = useState(false);
    const [isLoaderVisible, setIsLoaderVisible] = useState(false)
    const [declaration, setDeclaration] = useState(false);

    const [selectedSellerPOItemIds, setSelectedSellerPOItemIds] = useState([])
    const [poPunchItems, setPOPunchItems] = useState()
    const [sellerPO, setSellerPO] = useState([])
    const [prevSellerPO, setPrevSellerPO] = useState([])
    const [sellerPOItems, setSellerPOItems] = useState([])
    const [prevSellerPOItems, setPrevSellerPOItems] = useState([])
    const [sellerCompanyDetails, setSellerCompanyDetails] = useState({})
    const [companyTotalPIAmountDetails, setCompanyTotalPIAmountDetails] = useState({})
    const [sellerPIPunch, setSellerPIPunch] = useState([])
    const [sellerPIPunchItems, setSellerPIPunchItems] = useState([])
    const [sellerGRNQCPunch, setSellerGRNQCPunch] = useState([])
    const [PIPunchBookingLogs, setPIPunchBookingLogs] = useState([])
    const [materialDetails, setMaterialDetails] = useState([])
    const [adjustmentNotes, setAdjustmentNotes] = useState([])
    const [adjustmentNoteItems, setAdjustmentNoteItems] = useState([])
    const [data, setData] = useState({})
    const [piPunchFile, setPIPunchFile] = useState({})
    const [PIPunchCreatedUsers, setPIPunchCreatedUsers] = useState([])
    const [PMStates, setPMStates] = useState([])
    const [procmartCompanyBillAddrs, setProcmartCompanyBillAddrs] = useState([])
    const [sellerCompanyBillAddrs, setSellerCompanyBillAddrs] = useState([])
    const [selectedPMState, setSelectedPMState] = useState(null)
    const [selectedPMBillAddr, setSelectedPMBillAddr] = useState()
    const [approvalInstances, setApprovalInstances] = useState([])
    const [vendorPayments, setVendorPayments] = useState([])
    const [isEditPMState, setIsEditPMState] = useState(false)
    const [sellerBillAddrDetails, setSellerBillAddrDetails] = useState({})
    const [isPIPunchConfirmModalVisible, setIsPIPunchConfirmModalVisible] = useState(false)
    const [PIPunchSubmitData, setPIPunchSubmitData] = useState({})
    const [processLineItems, setProcessLineItems] = useState([])
    const [sellerPIPunchTickets, setSellerPIPunchTickets] = useState([])

    const dispatch = useDispatch()
    const usersData = useSelector(state => state.userDetails)
    const tdsSections = useSelector(state => state.common.tdsSections)
    const HSNMasterData = useSelector(state => state.common.HSNMaster)
    const materialBrands = useSelector((state) => state.common.materialBrands)
    const ticketSubCategoies = useSelector(state => state.common.ticketSubCategories || [])
    const approvals = useSelector((state) => state.common.approvals)

    const pmBranches = usersData.PMCompanyDetails?.companyPmBranches ? usersData.PMCompanyDetails.companyPmBranches : []
    const pmCompanyDetails = usersData.PMCompanyDetails

    const pmCompanyConfig = getPMCompanyConfig(sellerPO?.pmCompanyId)
    let { numberLocale } = pmCompanyConfig


    let gstRates = pmCompanyConfig.GSTRates
    let gstOptions = []
    gstRates.map(eachGSTRate => gstOptions.push({label: eachGSTRate.toString(), GSTRate: eachGSTRate}))
   
    useEffect(() => {
        dispatch(fetchStates())
        dispatch(fetchMaterialBrands())
        dispatch(fetchTDSSections())
        dispatch(fetchHSNMasterData())
        dispatch(fetchTicketSubCategory(true))
        dispatch(fetchApprovals())
        return () => {
            dispatch(setSelectedSellerPO(null))
        }
    }, [])

    useEffect(() => {
        if (sellerPOId) {
            getSellerPO()
        }
    }, [sellerPOId])

    useEffect(() => {
        let data = {
            sellerPOId: sellerPOId
        }
        setData(data)
    }, [sellerPOId])

    useEffect(() => {
        if (props.sellerBillAddrDetails) {
            setSellerBillAddrDetails({...props.sellerBillAddrDetails})
        }
    }, [props.sellerBillAddrDetails])

    const getSellerPO = async (fetchEntireDocDetails) => {
        setIsLoaderVisible(true)

        let response
        if (sellerPOId) {
            response = await getSellerPOBySellerPOId(sellerPOId, fetchEntireDocDetails)
        }

        if (response?.failure) {
            dispatch(raiseToast({ severity: 'error', detail: response.data.error, summary: 'Seller PO not fetched', life: 3000 }))
        } else {
            const newSellerPO = response?.data.sellerPO
            const newSellerPOItems = response?.data.sellerPOItems
            const newSellerPIPunch = response?.data.sellerPIPunch.map(eachSellerPIPunch => ({ ...eachSellerPIPunch, toggleInputs: true }))
            const newSellerPIPunchItems = response?.data.sellerPIPunchItems
            const newSellerGRNQCPunch = response?.data.sellerGRNQCPunch
            const PIPunchBookingLogs = response?.data.PIPunchBookingLogs

            let buyerReqItemIds = []
            let materialIds = []
            newSellerPOItems?.map(eachSellerPOItem => buyerReqItemIds.push(eachSellerPOItem?.buyerReqItemId))
            newSellerPOItems?.map(eachSellerPOItem => materialIds.push(eachSellerPOItem?.materialId))
            let data = { buyerReqItemsIds: buyerReqItemIds }
            let materialDetailsRes = null

            if (newSellerPO?.expenseCategoryId) {
                materialDetailsRes = await getMaterialMasterAndTempMaterialIds({ materialIds: materialIds })
            } else {
                materialDetailsRes = await getMaterialItemsDataByBuyerReqItemIds(data)
            }
            const buyerPOId = newSellerPO?.buyerPOId
            const poPunchItemsRes = await getPOPunchItemByBuyerPOIds({ buyerPOIds: [buyerPOId] })

            if (poPunchItemsRes?.failure) {
                dispatch(raiseToast({ severity: 'error', detail: poPunchItemsRes.data.error, summary: 'PO Punch Items Not Fetched.', life: 3000 }))
            } else {
                setPOPunchItems(poPunchItemsRes?.data)
            }

            let sellerPIPunchIds = []
            newSellerPIPunch?.map(eachSellerPIPunch => sellerPIPunchIds.push(eachSellerPIPunch?.sellerPIPunchId))
            const relatedSellerDebitNotesRes = await getAdjustmentNotesBySellerPIPunchIds({ sellerPIPunchIds: sellerPIPunchIds })
            if (relatedSellerDebitNotesRes?.failure) {
                dispatch(raiseToast({ severity: 'error', detail: relatedSellerDebitNotesRes.data.error, summary: 'Seller Debit Notes Not Fetched', life: 3000 }))
            } else {
                setAdjustmentNotes(relatedSellerDebitNotesRes?.data?.adjustmentNote)
                setAdjustmentNoteItems(relatedSellerDebitNotesRes?.data?.adjustmentNoteItems)
            }

            let PIPunchCreatedUsers = []
            newSellerPIPunch?.map(eachSellerPIPunch => PIPunchCreatedUsers.push(eachSellerPIPunch?.createdBy))

            let usersRes = null
            if(PIPunchCreatedUsers.length > 0){
                usersRes = await getUsers({ userIds: PIPunchCreatedUsers, paginator: false })
            }
            if (usersRes?.failure) {
                dispatch(raiseToast({ severity: 'error', summary: 'User Response', detail: usersRes?.data.error, life: 3000 }))
            }

            let activeSellerPOItems = newSellerPOItems?.filter(eachSellerPOItem => eachSellerPOItem?.statusId === 3)
            let allProcessed = activeSellerPOItems?.map((eachSellerPOItem, index) => {
                let totalReceivedQty = 0
                newSellerPIPunchItems?.map(eachSellerPIPunchItem => {
                    if (eachSellerPIPunchItem.sellerPOItemId === eachSellerPOItem.sellerPOItemId && eachSellerPIPunchItem?.statusId === 1) {
                        totalReceivedQty += eachSellerPIPunchItem.qty
                    }
                })
                if (totalReceivedQty === eachSellerPOItem?.qty) {
                    return true
                } else {
                    return false
                }
            })
            let isAllProcessed = allProcessed?.every(eachItem => eachItem === true)

            let totalLogisticsAmountUsed = 0
            newSellerPIPunch?.map(eachSellerPIPunch => {
                if (eachSellerPIPunch?.statusId === 1) {
                    totalLogisticsAmountUsed += eachSellerPIPunch?.sellerPILogisticsWithTax
                }
            })
            let updatedSellerPO = {
                ...newSellerPO,
                isAllProcessed: isAllProcessed,
                logisticsAmountLeft: parseFloat(newSellerPO?.logisticsWithTax) - parseFloat(totalLogisticsAmountUsed),
                sellerPILogisticsWithTax: parseFloat(newSellerPO?.logisticsWithTax) - parseFloat(totalLogisticsAmountUsed),
            }

            let updatedSellerGRNQCPunch = newSellerGRNQCPunch?.filter(eachSellerGRNQCPunch => eachSellerGRNQCPunch?.statusId === 1)

            setPIPunchCreatedUsers(usersRes?.data?.data)
            setSellerPO(updatedSellerPO)
            setPrevSellerPO(updatedSellerPO)
            setSellerPOItems(newSellerPOItems)
            setPrevSellerPOItems(newSellerPOItems)

            const relatedSellerPIPunchDocNos = newSellerPIPunch?.map(eachSellerPIPunch => eachSellerPIPunch?.docNo)

            const approvalInstancesRes = await getApprovalInstancesByDocNos({docNos: relatedSellerPIPunchDocNos})
            if (approvalInstancesRes?.failure){
                dispatch(raiseToast({severity:'error', detail: approvalInstancesRes.data.error, summary:'Approval Instances Not Fetched', life: 3000}))
            }else{
                setApprovalInstances(approvalInstancesRes?.data)
            }

            const companyRes = await getCompanyById(newSellerPO?.companyId)
            // console.log("companyRes", companyRes)
            if (companyRes?.failure){
                dispatch(raiseToast({severity:'error', summary: 'Company', detail: companyRes?.data.error, life: 3000}))
            }

            const companyTotalPIAmountRes = await getTotalCompanyAmountByCompanyId(newSellerPO?.companyId)
            // console.log("companyTotalPIAmountRes", companyTotalPIAmountRes)
            if (companyTotalPIAmountRes?.failure){
                dispatch(raiseToast({severity:'error', summary: 'Company Total Transactions', detail: companyTotalPIAmountRes?.data.error, life: 3000}))
            }

            const vendorPaymentRes = await getVendorPaymentBySellerPOId(newSellerPO?.sellerPOId)
            if (vendorPaymentRes?.failure){
                dispatch(raiseToast({severity:'error', summary: 'Vendor Payment', detail: vendorPaymentRes?.data.error, life: 3000}))
            }

            let updatedSellerPOItems = newSellerPOItems
            
            setPIPunchCreatedUsers(usersRes?.data?.data)
            setSellerPO(updatedSellerPO)
            setSellerPOItems(updatedSellerPOItems)
            setSellerCompanyDetails(companyRes?.data)
            setCompanyTotalPIAmountDetails(companyTotalPIAmountRes?.data[0])
            setMaterialDetails(materialDetailsRes?.data)
            setSellerPIPunch(newSellerPIPunch)
            setSellerPIPunchItems(newSellerPIPunchItems)
            setSellerGRNQCPunch(updatedSellerGRNQCPunch)
            setPIPunchBookingLogs(PIPunchBookingLogs)
            setVendorPayments(vendorPaymentRes?.data)
            setProcessLineItems(response.data.processLineItems)
            setSellerPIPunchTickets(response.data.sellerPIPunchTickets)

            if(fetchEntireDocDetails){
                props.setSellerPOPdfURL(response?.data?.sellerPOPdfURL)
                props.setDocumentHTML(response?.data?.documentHTML)
            }

            const companyBillAddrsRes = await getCompanyBillAddrs({ companyIds: [updatedSellerPO.pmCompanyId, updatedSellerPO.companyId], statusIds: [1], paginator: false })
            if (companyBillAddrsRes.failure) {
                dispatch(raiseToast({ severity: 'error', summary: 'Billing Address', detail: companyBillAddrsRes.data.error, life: 3000 }))
            }
            
            let pmCompanyBillAddrs2 = companyBillAddrsRes.data.data.filter(eachCompanyBillAddr => eachCompanyBillAddr.companyId === updatedSellerPO.pmCompanyId)
            const pmCompanyBillAddrIds = pmCompanyDetails.companyBranches.map(eachCompanyBranch => eachCompanyBranch.primaryBillAddrId)
            const pmCompanyBillAddrs = pmCompanyDetails.companyBillAddrs.filter(eachCompanyBillAddr => pmCompanyBillAddrIds.includes(eachCompanyBillAddr.billAddrId))
            let sellerCompanyBillAddrs = companyBillAddrsRes.data.data.filter(eachCompanyBillAddr => eachCompanyBillAddr.companyId === updatedSellerPO.companyId)

            let selectedSellerBillAddr = sellerCompanyBillAddrs.find(eachBillAddr => eachBillAddr.billAddrId === updatedSellerPO.billAddrId)

            let statesRes = await getStatesData({paginator: false})
            if (statesRes.failure) {
                return dispatch(raiseToast({ severity: 'error', summary: 'States', detail: statesRes.data.error, life: 3000 }))
            }
            let states = statesRes.data.data

            const allStateIds = _.map(pmCompanyBillAddrs, 'stateId')
            const filteredStates = _.filter(states, (state) => allStateIds.includes(state.stateId))
            const updatedStateList = filteredStates.map(eachState => {
                const eachRelatedPMBillAddr = pmCompanyBillAddrs.find(eachBillAddr => eachBillAddr.stateId === eachState.stateId)
                
                return {
                    ...eachState,
                    gstinCode: eachRelatedPMBillAddr.gstinCode,
                    stateNameWithGstinCode: `${eachState.stateName} - (${eachRelatedPMBillAddr.gstinCode})`
                }
            })
            
            setPMStates(updatedStateList)
            
            const relatedPMBillAddr = pmCompanyBillAddrs2.find(eachBillAddr => eachBillAddr.billAddrId === updatedSellerPO.pmBillAddrId)

            setSelectedPMState(relatedPMBillAddr.stateId)
            setSelectedPMBillAddr(relatedPMBillAddr)
            
            setProcmartCompanyBillAddrs(pmCompanyBillAddrs)
            setSellerCompanyBillAddrs(sellerCompanyBillAddrs)
            setSellerBillAddrDetails(selectedSellerBillAddr)
            
        }
        setIsLoaderVisible(false)
    }

    const handleSellerGRNQCPunchRefresh = (updatedSellerGRNQCPunches) => {
        console.log("trigger updatedSellerGRNQCPunches", updatedSellerGRNQCPunches)
        setSellerGRNQCPunch([...updatedSellerGRNQCPunches])
    }
 
    const handleInputQtyChange = (e, sellerPOItemId, availableQty) => {
        const updatedSellerPOItems = sellerPOItems.map(eachSellerPOItem => {
            if (eachSellerPOItem.sellerPOItemId === sellerPOItemId) {
                if (e.target.value <= availableQty) {
                    return { ...eachSellerPOItem, [e.target.name]: e.target.value }
                } else {
                    dispatch(raiseToast({ severity: 'error', detail: `Available Qty : ${availableQty}`, life: 3000 }))
                    return { ...eachSellerPOItem, [e.target.name]: availableQty }
                }
            } else {
                return eachSellerPOItem
            }
        })
        const calculatedValues = calculateSellerPI(sellerPO, updatedSellerPOItems)

        setSellerPO(prevState => ({ ...prevState, ...calculatedValues?.sellerPIPunch }))
        setSellerPOItems(updatedSellerPOItems)
    }

    const handleInputChange = (e, availableAmt) => {
        if (e.target.name === "sellerPILogisticsWithTax") {
            if (e.target.value.length > 1 && e.target.value[0] === "0") {
                e.target.value = e.target.value.substring(1)
            }
            if (e.target.value === "") {
                e.target.value = 0
            }
            if (parseFloat(e.target.value) <= availableAmt) {
                let updatedSellerPO = { ...sellerPO, [e.target.name]: e.target.value }
                let calculatedValues = calculateSellerPI(updatedSellerPO, sellerPOItems)
                setSellerPO(calculatedValues.sellerPIPunch)
            } else {
                dispatch(raiseToast({ severity: 'error', detail: `Available Amount : ${availableAmt} Only`, life: 3000 }))
                let updatedSellerPO = { ...sellerPO, [e.target.name]: availableAmt }
                let calculatedValues = calculateSellerPI(updatedSellerPO, sellerPOItems)
                setSellerPO(calculatedValues.sellerPIPunch)
            }
        } else {
            setSellerPO(prevState => ({ ...prevState, [e.target.name]: e.target.value }))
        }
    }

    const handleInputGSTAndHSNChange = (e, sellerPOItemId) => {
        const updatedSellerPOItems = sellerPOItems.map(eachSellerPOItem => {
            if (eachSellerPOItem.sellerPOItemId === sellerPOItemId) {
                return { ...eachSellerPOItem, [e.target.name]: e.target.value }
            } else {
                return eachSellerPOItem
            }
        })
        const calculatedValues = calculateSellerPI(sellerPO, updatedSellerPOItems)

        setSellerPO(prevState => ({ ...prevState, ...calculatedValues?.sellerPIPunch }))
        setSellerPOItems(updatedSellerPOItems)
    }

    const handleHSNCodeBlur = (e, eachSellerPOItem) => {
        if (e.target.name === "HSNCode") {
            const relatedPrevSellerPOItem = prevSellerPOItems.find(eachPrevSellerPOItem => eachPrevSellerPOItem.sellerPOItemId === eachSellerPOItem.sellerPOItemId)
    
            const newHSN = e.target.value.toString()
            const oldHSN = relatedPrevSellerPOItem.HSNCode.toString()
    
            let isSACToHSNChanged = false
            let isHSNToSACChanged = false
    
            if (oldHSN.slice(0, 2) === '99' && oldHSN.length === 6 && newHSN.slice(0, 2) !== '99') {
                isSACToHSNChanged = true
            }
    
            if (oldHSN.slice(0, 2) !== '99' && newHSN.slice(0, 2) === '99' && newHSN.length === 6) {
                isHSNToSACChanged = true
            }
    
            let errorMessage = ""

            if (isSACToHSNChanged){
                errorMessage = "SAC Codes shouldn't be changed to HSNCode"
            }

            if (isHSNToSACChanged){
                errorMessage = "HSNCode shouldn't be changed to SACCode"
            }

            if (isSACToHSNChanged || isHSNToSACChanged){
                let updatedSellerPOItems = sellerPOItems.map(eachExistingSellerPOItem => {
                    if (eachSellerPOItem.sellerPOItemId === eachExistingSellerPOItem.sellerPOItemId){
                        return {...eachExistingSellerPOItem, HSNCode: oldHSN}
                    }
                    return eachExistingSellerPOItem
                })

                setSellerPOItems(updatedSellerPOItems)
                return dispatch(raiseToast({ severity: 'error', detail: errorMessage, life: 3000 }))
            }
        }
    }
    

    const handleEditGSTRateAndHSNCode = (e, sellerPOItemId, name) => {
        // const activeVendorPayments = vendorPayments.filter(eachVendorPayment => [10, 12, 9].includes(eachVendorPayment.statusId))
        // if(activeVendorPayments.length > 0){
        //     return dispatch(raiseToast({ severity: 'error', detail: `Payment was done for this seller po, So can't change GSTRate`, life: 3000 }))
        // }
        // setIsEditGSTRate(!isEditGSTRate)
        // setEditedGSTRateSellerPOItemId(sellerPOItemId)
        const updatedSellerPOItems = sellerPOItems.map(eachSellerPOItem => {
            if (eachSellerPOItem.sellerPOItemId === sellerPOItemId) {
                if (name === "GSTRate"){
                    return { ...eachSellerPOItem, isEditGSTRate: true }
                }else if (name === "HSNCode"){
                    return { ...eachSellerPOItem, isEditHSNCode: true }
                }
            } else {
                return eachSellerPOItem
            }
        })

        setSellerPOItems(updatedSellerPOItems)
    }

    const handleSellerPIChange = (e, sellerPIPunchId) => {
        const updatedSellerPIPunch = sellerPIPunch?.map(eachSellerPIPunch => {
            if (eachSellerPIPunch.sellerPIPunchId === sellerPIPunchId) {
                return { ...eachSellerPIPunch, [e.target.name]: e.target.value }
            } else {
                return eachSellerPIPunch
            }
        })
        setSellerPIPunch(updatedSellerPIPunch)
    }

    const hasGSTRateAndHSNChangedForSellerPOItems = (prevSellerPOItems, currentSellerPOItems) => {
        let updatedPrevSellerPOItems = []
        let isGSTRateChanged = false
        let isHSNCodeChanged = false

        prevSellerPOItems.forEach(eachPrevSellerPOItem => {
            let relatedCurrentSellerPOItem = currentSellerPOItems.find(item => item.sellerPOItemId === eachPrevSellerPOItem.sellerPOItemId)

            if (relatedCurrentSellerPOItem && eachPrevSellerPOItem.GSTRate !== relatedCurrentSellerPOItem.GSTRate) {
                eachPrevSellerPOItem = { ...eachPrevSellerPOItem, GSTRate: relatedCurrentSellerPOItem.GSTRate }
                isGSTRateChanged = true
            }

            if (relatedCurrentSellerPOItem && eachPrevSellerPOItem.HSNCode !== relatedCurrentSellerPOItem.HSNCode) {
                eachPrevSellerPOItem = { ...eachPrevSellerPOItem, HSNCode: relatedCurrentSellerPOItem.HSNCode, isHSNCodeChanged: true }
                isHSNCodeChanged = true
            }
            updatedPrevSellerPOItems.push(eachPrevSellerPOItem)
        })

        return { isGSTRateChanged, isHSNCodeChanged, updatedPrevSellerPOItems }


    }

    const hasPMStateChanged = () => {
        const pmCompanyBillAddr = procmartCompanyBillAddrs?.find(eachBillAddr => eachBillAddr.billAddrId === selectedPMBillAddr.billAddrId)
        let gstType = pmCompanyBillAddr?.stateId === parseInt(sellerBillAddrDetails?.stateId) ? 'CS' : 'I'
        if (pmCompanyBillAddr?.gstinCode && !["URP", "URD"].includes(pmCompanyBillAddr?.gstinCode) && sellerBillAddrDetails?.gstinCode && !["URP", "URD"].includes(sellerBillAddrDetails?.gstinCode)) {
            gstType = parseInt(pmCompanyBillAddr?.gstinCode?.slice(0, 2)) === parseInt(sellerBillAddrDetails?.gstinCode?.slice(0, 2)) ? 'CS' : 'I'
        }

        const prevCompanyBillAddr = procmartCompanyBillAddrs?.find(eachBillAddr => eachBillAddr.billAddrId === sellerPO.pmBillAddrId)
        
        if (prevCompanyBillAddr?.stateId != selectedPMState) {
            return { isPMStateChanged: true, updatedSellerPO: { ...prevSellerPO, pmBillAddrId: selectedPMBillAddr.billAddrId, GSTType: gstType } }
        }

        return { isPMStateChanged: false, updatedSellerPO: {...prevSellerPO, GSTType: gstType} }

    }
    const handlePIPunchClick = async () => {
        const validateErrs = await validateInputs(piPunchSchema, { ...sellerPO, sellerPIDocProof: piPunchImageName, checked: checked })
        if (validateErrs.error) {
            setPIPunchErrors(validateErrs.error)
        } else {
            setPIPunchErrors({})

            const activeRoleId = usersData?.activeRoleId
            const relatedUserCompany = usersData?.rolesList?.find(eachRole => eachRole?.userRoleId === activeRoleId)

            const updatedSellerPOItems = sellerPOItems.map(eachSellerPOItem => {
                let latestBPOPunchItemId = null
                let relatedBPOPunchItems = poPunchItems.filter(eachPOPunchItem => eachPOPunchItem.buyerPOItemId === eachSellerPOItem.buyerPOItemId)
                if (relatedBPOPunchItems.length > 0) {
                    let latestBPOPunchItem = relatedBPOPunchItems.reduce((latestPunchItem, currentPunchItem) => {
                        return !latestPunchItem || currentPunchItem.poPunchItemId > latestPunchItem.poPunchItemId ? currentPunchItem : latestPunchItem
                    }, relatedBPOPunchItems[0])

                    if (latestBPOPunchItem) {
                        latestBPOPunchItemId = latestBPOPunchItem.poPunchItemId
                    }
                }

                return (
                    {
                        sellerPOId: eachSellerPOItem?.sellerPOId,
                        buyerPOId: eachSellerPOItem?.buyerPOId,
                        buyerReqId: eachSellerPOItem?.buyerReqId,
                        fileNo: eachSellerPOItem?.fileNo,
                        docNo: eachSellerPOItem?.docNo,
                        materialId: eachSellerPOItem?.materialId,
                        GSTRate: eachSellerPOItem?.GSTRate,
                        HSNCode: eachSellerPOItem?.HSNCode,
                        buyerPOItemId: eachSellerPOItem?.buyerPOItemId,
                        buyerReqItemId: eachSellerPOItem?.buyerReqItemId,
                        sellerPOItemId: eachSellerPOItem?.sellerPOItemId,
                        pmCompanyId: relatedUserCompany?.pmCompanyId,
                        pmBranchId: relatedUserCompany?.branchId,
                        sellerPOQty: eachSellerPOItem?.qty,
                        qty: round(eachSellerPOItem?.inputQty),
                        createdBy: usersData?.userId,
                        updatedBy: usersData?.userId,
                        poPunchItemId: latestBPOPunchItemId
                    }
                )
            })

            const relatedSellerPOItems = updatedSellerPOItems.filter(eachSellerPOItem => eachSellerPOItem?.qty > 0)
            if (!relatedSellerPOItems.length > 0) {
                return dispatch(raiseToast({ severity: 'error', detail: 'Please Enter quantity', life: 3000 }))
            } else {
                if (piPunchImageName) {
                    sellerPO.sellerPIUploadedDate = moment(new Date()).format("YYYY-MM-DD")
                    if (Object.values(piPunchFile)?.length > 0) {
                        piPunchImageName = null
                        sellerPO.sellerPIUploadFile = piPunchFile
                    }
                }
                let data = {
                    sellerPIPunch: { 
                        sellerPOId: sellerPO?.sellerPOId,
                        buyerPOId: sellerPO?.buyerPOId,
                        buyerReqId: sellerPO?.buyerReqId,
                        fileNo: sellerPO?.fileNo,
                        docNo: sellerPO?.docNo,
                        parentDocNo: sellerPO?.docNo,
                        sellerPIDate: sellerPO?.sellerPIDate,
                        sellerPIUploadedDate: sellerPO?.sellerPIUploadedDate,
                        sellerPICalculatedTotalAmount: sellerPO?.sellerPICalculatedTotalAmount,
                        sellerPIAmountBeforeTax: sellerPO?.sellerPIAmountBeforeTax,
                        sellerPILogisticsWithTax: sellerPO?.sellerPILogisticsWithTax,
                        logisticsBeforeTax: sellerPO.logisticsBeforeTax,
                        sellerPITotalAmount: sellerPO?.sellerPITotalAmount,
                        sellerPINumber: sellerPO?.sellerPINumber?.trim(),
                        companyId: sellerPO?.companyId,
                        pmCompanyId: relatedUserCompany?.pmCompanyId,
                        pmBranchId: relatedUserCompany?.branchId,
                        pmBillAddrId: sellerPO?.pmBillAddrId,
                        sellerPIDocProof: piPunchFile?.url,
                        sellerPIUploadFile: piPunchFile,
                        createdBy: usersData?.userId,
                        updatedBy: usersData?.userId
                    },
                    sellerPOId : sellerPOId,
                    prevSellerPIPunch : sellerPIPunch,
                    sellerPIPunchItems : relatedSellerPOItems,
                    isApprovedByManager: checked
                }
                let totalLogisticsAmount = 0
                sellerPIPunch?.map(eachSellerPIPunch => {
                    if (eachSellerPIPunch?.statusId === 1) {
                        totalLogisticsAmount += parseFloat(eachSellerPIPunch?.sellerPILogisticsWithTax)
                    }
                })
                let totalQtyPunched = updatedSellerPOItems?.every((eachSellerPOItem, index) => {
                    let totalReceivedQty = 0
                    sellerPIPunchItems?.map(eachSellerPIPunchItem => {
                        if (eachSellerPIPunchItem.sellerPOItemId === eachSellerPOItem.sellerPOItemId && eachSellerPIPunchItem?.statusId === 1) {
                            totalReceivedQty += eachSellerPIPunchItem.qty
                        }
                    })

                    return totalReceivedQty + parseFloat(eachSellerPOItem?.qty) === eachSellerPOItem?.sellerPOQty
                })

                if (totalQtyPunched && (round(totalLogisticsAmount + data?.sellerPIPunch?.sellerPILogisticsWithTax, 2)) !== round(sellerPO?.logisticsWithTax, 2)) {
                    setSellerPO(prevState => ({ ...prevState, sellerPILogisticsWithTax: sellerPO?.logisticsAmountLeft }))
                    return dispatch(raiseToast({ severity: 'error', detail: `Please Add the remaning Logistics Tax Amount Rs.${sellerPO?.logisticsAmountLeft}`, life: 3000 }))
                }

                if (!checked && (Math.abs(data?.sellerPIPunch?.sellerPICalculatedTotalAmount - data?.sellerPIPunch?.sellerPITotalAmount) > 2)) {
                    return dispatch(raiseToast({ severity: 'error', detail: 'Difference between the amounts should not be greater than 2', life: 3000 }))
                }

                let isSellerBillAddrIdChanged = sellerPO.billAddrId !== sellerBillAddrDetails.billAddrId

                let { isGSTRateChanged, isHSNCodeChanged, updatedPrevSellerPOItems } = hasGSTRateAndHSNChangedForSellerPOItems(prevSellerPOItems, sellerPOItems)

                data.isGSTRateChanged = isGSTRateChanged
                data.isHSNCodeChanged = isHSNCodeChanged
                data.isSellerBillAddrIdChanged = isSellerBillAddrIdChanged
                data.updatedSellerPOItems = updatedPrevSellerPOItems

                const HSNUpdatedSellerPOItems = updatedPrevSellerPOItems.filter(eachItem => eachItem.isHSNCodeChanged)
               
                let isInvalidHSNCodeExists = false
                isInvalidHSNCodeExists = HSNUpdatedSellerPOItems.some(eachSellerPOItem => {
                    let relatedHSN = HSNMasterData?.find(eachHSN => eachHSN?.HSNCode === parseFloat(eachSellerPOItem?.HSNCode))
                    return !relatedHSN
                })
               
                if (isInvalidHSNCodeExists){
                    return dispatch(raiseToast({severity:'error', detail:'Please Enter a Valid HSNCode', life: 3000}))
                }

                if (!sellerBillAddrDetails?.billAddrId){
                    return dispatch(raiseToast({severity:'error', detail:'Please Select Seller Bill Addr', life: 3000}))
                }


                let { isPMStateChanged, updatedSellerPO } = hasPMStateChanged()
                data.isPMStateChanged = isPMStateChanged
                data.updatedSellerPO = {...updatedSellerPO, billAddrId: sellerBillAddrDetails?.billAddrId}

                let windowMessage = "Do you want to continue for Punch?"

                if (checked){
                    windowMessage = "Approval Request will be created for the PI Punch. Do you want to continue for Punch?"
                }

                if (!checked && !data?.sellerPIPunch?.sellerPIDocProof){
                    return dispatch(raiseToast({severity:'error', detail:'Please Upload the PI Document', life: 3000}))
                }

                const isServiceHSNsProductsExists = data.sellerPIPunchItems.some(eachSellerPIPunchItem => {
                    if(eachSellerPIPunchItem.HSNCode.toString().slice(0, 2) === '99' && eachSellerPIPunchItem.HSNCode.toString().length === 6){
                        return true
                    }
                    return false
                })

                const isGoodsHSNProductsExists = data.sellerPIPunchItems.some(eachSellerPIPunchItem => {
                    if(eachSellerPIPunchItem.HSNCode.toString().slice(0, 2) === '99' && eachSellerPIPunchItem.HSNCode.toString().length === 6){
                        return false
                    }
                    return true
                })

                const isAllItemsAreServices = data.sellerPIPunchItems.every(eachSellerPIPunchItem => {
                    if(eachSellerPIPunchItem.HSNCode.toString().slice(0, 2) === '99' && eachSellerPIPunchItem.HSNCode.toString().length === 6){
                        return true
                    }
                    return false
                })

                const isAutoGRNApplicable = isAllItemsAreServices && piPunchFile.url && sellerPO.expenseCategoryId

                //added 1 second delay to display toast msg after pi punch confirm model visible
                if(isAutoGRNApplicable){
                    setTimeout(() => {
                        dispatch(raiseToast({ severity: 'warn', detail: 'This is an expense PO with services only, so GRN will automatically be done'}))
                    }, 1000)
                }

                const advanceTDSVendorPayment = vendorPayments.find(eachVendorPayment => [12, 10, 9].includes(eachVendorPayment.statusId) && ["payAdvPO", "payAdvDelivery", "payPDCDelivery"].includes(eachVendorPayment.paymentTerm) && eachVendorPayment.tdsAmount > 0)

                if (pmCompanyConfig.isTDSAutomated){
                    if(!isAllItemsAreServices && isServiceHSNsProductsExists && advanceTDSVendorPayment){
                        /*if([1, 8].includes(sellerPO.tdsSectionId)){
                            return dispatch(raiseToast({severity:'error', detail:'Services cannot be punched in this PI'}))
                        }*/
                        if(sellerPO.tdsAmtReqTypeId === 1){ // [1, 8].includes(sellerPO.tdsSectionId)
                            dispatch(raiseToast({severity:'warning', detail:'services TDS will be applicable on this, as was initially selected - if you do not want this, cancel TDS VP and re-process', life: 9000}))
                        }
                    }

                    if(isGoodsHSNProductsExists && isServiceHSNsProductsExists){
                        if(sellerPO.tdsAmtReqTypeId === 2){
                            return dispatch(raiseToast({severity:'error', detail:'Please punch services and goods seperately'}))
                        }
                    }
                }

                setPIPunchSubmitData({...data})
                setIsPIPunchConfirmModalVisible(true)
            }
        }
    }

    const handlePIPunchConfirmModal = async(sellerGSTINDeclaration, PMGSTINDeclaration, PINoDeclaration, PIDateDeclaration, PIAmountDeclaration) => {
        if(!sellerGSTINDeclaration){
            return dispatch(raiseToast({severity:'warn', detail: 'Please confirm seller GSTIN', life: 3000}))
        }

        if(!PMGSTINDeclaration){
            return dispatch(raiseToast({severity:'warn', detail: 'Please confirm procmart GSTIN', life: 3000}))
        }

        if(!PINoDeclaration){
            return dispatch(raiseToast({severity:'warn', detail: 'Please confirm PI Number', life: 3000}))
        }

        if(!PIDateDeclaration){
            return dispatch(raiseToast({severity:'warn', detail: 'Please confirm PI Date', life: 3000}))
        }

        if(!PIAmountDeclaration){
            return dispatch(raiseToast({severity:'warn', detail: 'Please confirm PI Amount', life: 3000}))
        }

        let piPunchConfirmMessage = ""

        if (PIPunchSubmitData.isGSTRateChanged) {
            piPunchConfirmMessage += "GSTRate for these items were changed."
        }
        if (checked){
            piPunchConfirmMessage += "Approval Request will be created for the PI Punch."
        }

        let sellerCompanyTotalPIAmount = parseFloat(companyTotalPIAmountDetails?.totalAmount) + parseFloat(PIPunchSubmitData.sellerPIPunch.sellerPICalculatedTotalAmount)

        const isServiceHSNsProductsExists = PIPunchSubmitData?.sellerPIPunchItems?.some(eachSellerPIPunchItem => {
            if(eachSellerPIPunchItem.HSNCode.toString().slice(0, 2) === '99' && eachSellerPIPunchItem.HSNCode.toString().length === 6){
                return true
            }
            return false
        })
        
        if (pmCompanyConfig.isTDSAutomated){
            let tdsSection
            if(sellerPO.companyId !== sellerPO.pmCompanyId){
                if (isServiceHSNsProductsExists){
                    if (sellerCompanyDetails.tdsSectionId === 1 || !sellerCompanyDetails.tdsSectionId) {
                        return dispatch(raiseToast({ severity: 'error', detail: "Services are not enabled for the vendor - please enable by selecting correct service Type in Companies Page.", life: 3000 }))
                    }else{
                        tdsSection = tdsSections.find(echTDSSection => echTDSSection.tdsSectionId === sellerCompanyDetails.tdsSectionId)
                        piPunchConfirmMessage += "Service TDS will be applied for this PI Punch."
                    }
                }
                else if (sellerCompanyDetails.tdsSection194q){ // || sellerCompanyTotalPIAmount >= 5000000
                    tdsSection = tdsSections.find(echTDSSection => echTDSSection.tdsSectionId === 1)
                    piPunchConfirmMessage += "TDS 194Q will be applied for this PI Punch."
                }
                else{
                    tdsSection = tdsSections.find(echTDSSection => echTDSSection.tdsSectionId === 8) // NO TDS
                }
            } else {
                tdsSection = tdsSections.find(echTDSSection => echTDSSection.tdsSectionId === 8)
            }
            
            PIPunchSubmitData.sellerPIPunch.tdsSection = tdsSection.tdsSectionName
            let tdsValue 
            if (sellerCompanyDetails?.panCode && sellerCompanyDetails?.panCode[3] === "P"){
                tdsValue = tdsSection.individualTDSRate
            }else{
                tdsValue = tdsSection.othersTDSRate
            }
            PIPunchSubmitData.sellerPIPunch.tdsSectionId = tdsSection.tdsSectionId
            PIPunchSubmitData.sellerPIPunch.tdsValue = tdsValue
            PIPunchSubmitData.sellerPIPunch.tdsAmount = PIPunchSubmitData.sellerPIPunch.sellerPIAmountBeforeTax * tdsValue * 0.01
        }else{
            let totalTDSAmount = 0
            PIPunchSubmitData.sellerPIPunchItems.map(eachSellerPIPunchItem => {
                const relatedSellerPOItem = sellerPOItems.find(eachSellerPOItem => eachSellerPOItem.sellerPOItemId === eachSellerPIPunchItem.sellerPOItemId)

                if (sellerPO.logisticsTDSValue){
                    totalTDSAmount += (sellerPO.logisticsBeforeTax * sellerPO.logisticsTDSValue * 0.01)
                }
                totalTDSAmount += (eachSellerPIPunchItem.qty * relatedSellerPOItem.unitPrice * relatedSellerPOItem.tdsValue * 0.01)
            })

            PIPunchSubmitData.sellerPIPunch.tdsAmount =  totalTDSAmount
        }

        //piPunchConfirmMessage += "Do you want to Punch?"

        if (window.confirm(piPunchConfirmMessage)) {
            setIsLoaderVisible(true)
            const response = await insertPIPunch(PIPunchSubmitData)
            if (response.failure) {
                if (response.status === 409) {
                    const { errorDetails } = response.data
                    dispatch(raiseToast({
                        severity: 'error',
                        detail: getSellerPODuplicateErrorDetail(errorDetails.sellerPODocNos),
                        life: 6000
                    }))
                } else {
                    dispatch(raiseToast({ severity: 'error', detail: response.data.error, summary: 'PI Punch', life: 3000 }))
                }
            } else {
                dispatch(raiseToast({ severity: 'success', detail: 'PI Punch is inserted', life: 3000 }))
            }
            setPIPunchImageName("")
            setPIPunchFile({})
            setIsPIPunchConfirmModalVisible(false)
            getSellerPO(PIPunchSubmitData.isPMStateChanged || PIPunchSubmitData.isGSTRateChanged ? true : false)
            setDeclaration(false)
            setIsEditPMState(false)
        }
    }

    const getSellerPODuplicateErrorDetail = (sellerPODocNos) => {

        const isCurrentIncluded = sellerPODocNos.includes(sellerPO.docNo)
        const otherSPODocNos = sellerPODocNos.filter(eachSPODocNo => eachSPODocNo !== sellerPO.docNo)

        return (
            <span>
                PI Punch cannot be processed as we have found an existing PI Punch
                {isCurrentIncluded && (
                    <>
                        &nbsp;with the current Seller PO No:&nbsp;
                        <strong style={{ color: '#00baaa' }}>{sellerPO.docNo}</strong>
                        <CopyToClipboard text={sellerPO.docNo} />
                    </>
                )}
                {otherSPODocNos.length > 0 && (
                    <>
                        {isCurrentIncluded ? ' and also with other Seller PO No(s): ' : ' with Seller PO No(s): '}
                        {otherSPODocNos.map((eachDocNo, index) => (
                            <span key={index}>
                                <strong style={{ color: '#00baaa' }}>{eachDocNo}</strong>
                                <CopyToClipboard text={eachDocNo} />
                                {index < otherSPODocNos.length - 1 ? ', ' : ''}
                            </span>
                        ))}
                    </>
                )}
                . To continue, please cancel the previous PI Punch{otherSPODocNos.length > 1 ? 'es' : ''}.
            </span>
        )
    }
    


    const handleSelectClick = (sellerPOItemId) => {
        if (selectedSellerPOItemIds.includes(sellerPOItemId)) {
            const updatedSellerPOItemIds = selectedSellerPOItemIds.filter(eachSellerPOItemId => eachSellerPOItemId !== sellerPOItemId)
            setSelectedSellerPOItemIds(updatedSellerPOItemIds)
        } else {
            const updatedSellerPOItemIds = [...selectedSellerPOItemIds, sellerPOItemId]
            setSelectedSellerPOItemIds(updatedSellerPOItemIds)
        }
    }

    const handleCheckBoxClick = (e) => {
        if (e.checked) {
            const relatedSellerPOItemIds = []
            sellerPOItems.forEach(eachSellerPOItem => {
                if ([2,3,8,11,14,15,16,17,18].includes(eachSellerPOItem.followUpStatusId) || sellerPO.expenseCategoryId) {
                    relatedSellerPOItemIds.push(eachSellerPOItem.sellerPOItemId)
                }
            })        
            setSelectedSellerPOItemIds(relatedSellerPOItemIds)
        } else {
            setSelectedSellerPOItemIds([])
        }
    }

    const handlePMStateChange = (e) => {
        setSelectedPMState(e.target.value)
        const relatedPMCompanyBillAddrs = procmartCompanyBillAddrs?.find(eachBillAddr => eachBillAddr.stateId === e.target.value)
        setSelectedPMBillAddr(relatedPMCompanyBillAddrs)
    }

    const handleResetClick = () => {
        if (selectedSellerPOItemIds?.length > 0) {
            const updatedSellerPOItems = sellerPOItems.map(eachSellerPOItem => {
                if (selectedSellerPOItemIds.includes(eachSellerPOItem.sellerPOItemId)) {
                    return { ...eachSellerPOItem, inputQty: "" }
                }
                return eachSellerPOItem
            })
            const calculatedValues = calculateSellerPI(sellerPO, updatedSellerPOItems)
            setSellerPO(prevState => ({ ...prevState, ...calculatedValues.sellerPIPunch }))
            setSellerPOItems(calculatedValues.sellerPIPunchItems)
            setSelectedSellerPOItemIds([])
        } else {
            dispatch(raiseToast({ severity: 'warn', detail: 'Select the Items', life: 3000 }))
        }
    }

    const handleApplyClick = () => {
        if (selectedSellerPOItemIds?.length > 0) {
            const updatedSellerPOItems = sellerPOItems?.map((eachSellerPOItem) => {
                if (eachSellerPOItem?.statusId === 3){
                    let totalReceivedQty = 0
                    sellerPIPunchItems?.map(eachSellerPIPunchItem => {
                        if (eachSellerPIPunchItem.sellerPOItemId === eachSellerPOItem.sellerPOItemId && eachSellerPIPunchItem?.statusId === 1) {
                            totalReceivedQty += eachSellerPIPunchItem.qty
                        }
                    })
                    if (selectedSellerPOItemIds.includes(eachSellerPOItem.sellerPOItemId)) {
                        return { ...eachSellerPOItem, inputQty: eachSellerPOItem?.qty - totalReceivedQty }
                    }
                }
                return eachSellerPOItem
            })
            const calculatedValues = calculateSellerPI(sellerPO, updatedSellerPOItems)
            setSellerPO(prevState => ({ ...prevState, ...calculatedValues?.sellerPIPunch }))
            setSellerPOItems(calculatedValues?.sellerPIPunchItems)
            setSelectedSellerPOItemIds([])
        } else {
            dispatch(raiseToast({ severity: 'warn', detail: 'Select the Items', life: 3000 }))
        }
    }

    const handleEditClick = (sellerPIPunchId) => {
        const updatedSellerPIPunch = sellerPIPunch?.map(eachSellerPIPunch => {
            if (eachSellerPIPunch.sellerPIPunchId === sellerPIPunchId) {
                if(eachSellerPIPunch?.sellerPIDate){
                    return { ...eachSellerPIPunch, toggleInputs: !eachSellerPIPunch.toggleInputs, canEditSellerPIDate: false }
                }else{
                    return { ...eachSellerPIPunch, toggleInputs: !eachSellerPIPunch.toggleInputs, canEditSellerPIDate: true }
                }
            }
            return eachSellerPIPunch
        })
        setSellerPIPunch(updatedSellerPIPunch)
    }

    const handleSaveClick = async (sellerPIPunchId) => {
        const relatedPIPunch = sellerPIPunch?.find(eachSellerPIPunch => eachSellerPIPunch.sellerPIPunchId === sellerPIPunchId)
        if (relatedPIPunch.sellerPIDocProof && !relatedPIPunch.sellerPIUploadedDate) {
            relatedPIPunch.sellerPIUploadedDate = moment(new Date()).format("YYYY-MM-DD")
        }

        relatedPIPunch.updatedAt = new Date()
        const validateErrs = await validateInputs(piPunchSchema, { ...relatedPIPunch, checked: false })
        
        if (!relatedPIPunch?.sellerPIDocProof) {
            return dispatch(raiseToast({ severity: 'error', detail: 'Please Upload the PI Document', life: 3000 }))
        }
        if (!relatedPIPunch?.sellerPINumber) {
            return dispatch(raiseToast({ severity: 'error', detail: 'Please Enter the PI Number', life: 3000 }))
        } else {
            relatedPIPunch.sellerPINumber = relatedPIPunch?.sellerPINumber?.trim()
        }
        if (!relatedPIPunch?.sellerPIDate) {
            return dispatch(raiseToast({ severity: 'error', detail: 'Please Enter the PI Date', life: 3000 }))
        }
        if (!relatedPIPunch?.sellerPITotalAmount) {
            return dispatch(raiseToast({ severity: 'error', detail: 'Please Enter the PI Amount', life: 3000 }))
        }
        if (Math.abs(relatedPIPunch?.sellerPICalculatedTotalAmount - relatedPIPunch?.sellerPITotalAmount) > 2) {
            dispatch(raiseToast({ severity: 'error', detail: 'Difference between the amounts should not be greater than 2', life: 3000 }))
        } else {
            const response = await updateSellerPIPunch(sellerPIPunchId, relatedPIPunch)
            if (response.failure) {
                dispatch(raiseToast({ severity: 'error', summary: response.data.error, detail: 'PI Punch Not Updated', life: 3000 }))
            } else {
                dispatch(raiseToast({ severity: 'success', detail: 'PI Punch has been Updated', life: 3000 }))
            }
            setChecked(false)
            setPIPunchImageName(null)
            getSellerPO()
        }
    }

    const handlePIDoc = (sellerPIPunchId, name, value, fileName) => {
        const updatedSellerPIPunches = sellerPIPunch.map(eachSellerPIPunch => {
            if (eachSellerPIPunch.sellerPIPunchId === sellerPIPunchId) {
                let newSellerPIPunch = { ...eachSellerPIPunch, [name]: value, uploadFileName: fileName }
                return newSellerPIPunch
            } else {
                return eachSellerPIPunch
            }
        })
        setSellerPIPunch(updatedSellerPIPunches)
    }

    const handleDeleteSellerPIPunch = async (sellerPIPunchId) => {
        setIsLoaderVisible(true)
        const deletedSellerPIPunchRes = await deleteSellerPIPunch(sellerPIPunchId)

        if (deletedSellerPIPunchRes.failure) {
            setIsLoaderVisible(false)
            return dispatch(raiseToast({ severity: 'error', summary: "PI punch Deletion", detail: deletedSellerPIPunchRes.data.error, life: 3000 }))
        }
        else {
            getSellerPO()
        }
        setIsLoaderVisible(false)
    }

    const fileUploadHandler = async ({ files, options }, doc_name, sellerPIPunchId) => {
        const { fileArr, error, errorMsg } = await getUploadedFileObj({ files, options, documentName: doc_name })
        if (error) {
            return dispatch(raiseToast({ severity: 'error', detail: errorMsg, life: 3000 }))
        }
        setPIPunchFile(prevState => ({
            url: fileArr[0].objectURL,
            documentName: fileArr[0].documentName,
            fileName: fileArr[0].fileName,
            dataURI: fileArr[0].dataURI,
            inputName: fileArr[0].inputName,
        }))

        setPIPunchImageName(fileArr[0])
        if (sellerPIPunchId) {
            handlePIDoc(sellerPIPunchId, fileArr[0].inputName,fileArr[0].dataURI, fileArr[0].fileName)
        }
        else {
            setPIPunchImageName(fileArr[0])
        }
    }

    const uploadSellerPIDocument = async (e, doc_name, file_name, data_uri, input_name, sellerPIPunchId) => {
        let data = {
            doc_name,
            file_name,
            data_uri
        }

        let response = await uploadFile(data)

        if (response) {
            if (sellerPIPunchId) {
                handlePIDoc(sellerPIPunchId, input_name, response.data)
            } else {
                setPIPunchImageName(response.data)
            }
        }
    }

    const removeSellerPIDocument = (event, sellerPIPunchId, name) => {
        event.stopPropagation();
        if (sellerPIPunchId) {
            handlePIDoc(sellerPIPunchId, name, "")
            setPIPunchImageName(null)
        } else {
            setPIPunchImageName(null)
        }
    }

    const handleApproveByManager = (e) => {
        setChecked(e.checked)
        if (e.checked) {
            let updatedSellerPO = {
                ...sellerPO,
                sellerPINumber: "",
                sellerPIDate: null,
                sellerPITotalAmount: null
            }
            setSellerPO(updatedSellerPO)
        }
    }

    const handleSellerBillAddr = (billAddrId) => {
        const selectedBillAddr = sellerCompanyBillAddrs.find(eachCompanyBillAddr => eachCompanyBillAddr?.billAddrId === billAddrId)
        setSellerBillAddrDetails(selectedBillAddr)
    }

    let logisticsTDSSection = ""
    if (sellerPO?.logisticsTDSSection) {
        logisticsTDSSection = sellerPO?.logisticsTDSSection
    }
    if (sellerPO?.logisticsTDSValue) {
        logisticsTDSSection += ` | ${sellerPO?.logisticsTDSValue}%`
    }

    let minPIDate = null
    const currentDate = new Date();
    const currentDay = currentDate.getDate();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    if (currentDay <= 7) {
        // If current day is 7th or before, set minDate to previous month's currentDay
        minPIDate = new Date(currentYear, currentMonth - 1, currentDay);
    } else {
        // If current day is after 7th, set minDate to current month's 1st day
        minPIDate = new Date(currentYear, currentMonth, 1);
    }

    const sellerPOItemsWithQty = sellerPOItems.filter(eachPOItem => parseFloat(eachPOItem.inputQty) > 0)

    let isInvoiceEnableForPMBranch = false
    const relatedPMBranchDetail = pmBranches.find(eachBranch => eachBranch.branchId === sellerPO?.pmBranchId)
    if(relatedPMBranchDetail?.isInvoicingEnabled){
        isInvoiceEnableForPMBranch = true
    }

    let areServiceHSNsProducts = false
    if (!isInvoiceEnableForPMBranch) {
        areServiceHSNsProducts = sellerPOItemsWithQty.every(eachPOItem => {
            if (eachPOItem.HSNCode.toString().slice(0, 2) === '99') {
                return true
            }
            return false
        })
    }

    let piPunchDisableCond = true
    if(isInvoiceEnableForPMBranch){
        piPunchDisableCond = false
    }
    else{
        if(areServiceHSNsProducts) {
            piPunchDisableCond = false
        }
    }

    piPunchDisableCond = !sellerPOItemsWithQty.length > 0 || (piPunchDisableCond || sellerPO?.isAllProcessed || sellerPO?.statusId === 6 || !declaration)

    const isCashPayment = false
    
    const relatedPMState = PMStates.find(eachState => eachState.stateId === selectedPMState)
    const relatedPMBillAddr = procmartCompanyBillAddrs.find(eachPMBillAddr => eachPMBillAddr.stateId === selectedPMState)

    const isActivePIPunchExists = sellerPIPunch.some(eachPIPunch => eachPIPunch.statusId === 1)
    
    let updatedSellerPOItems = sellerPOItems

    if (sellerPO?.statusId !== 6){
        updatedSellerPOItems = sellerPOItems?.filter(eachSellerPOItem => eachSellerPOItem?.statusId === 3)
    }

    const isHSNEntryAllowed = pmCompanyConfig.HSNEntryAllowed
    console.log("piPunchImageName", piPunchImageName)

    return (
        // <Dialog header={renderHeader} className="pi-punch-dialog" visible={visiblePIPunch} style={{ width: '90vw', height: '85vh', backgroundColor: '#f8f8f8' }} onHide={() => handleOnHideDialog()} >
        <>
            <div className="pi-punch-modal">
                <Loading visible={isLoaderVisible} />
                {
                    !sellerPOId &&
                    <div className="flex justify-content-center">
                        <p className="font-bold">Please Select the Seller PO Doc Number.</p>
                    </div>
                }
                {
                    sellerPOId &&
                    <TabView className="mt-1">
                        <TabPanel header="PI Details" className="pi-details">
                            <div className="mt-2">
                                <div className="grid ">
                                    <div className="flex flex-row col-12 mb-2 md:col-3 lg:col-3 lg:mb-0 align-items-center">
                                        <CheckboxField label='Approved by the Manager Over Mail' onChange={e => handleApproveByManager(e)} checked={checked} permissions={[128]} />
                                    </div>
                                    <div className="flex flex-row col-12 mb-2 md:col-5 lg:col-2 lg:mb-0 align-items-center"></div>
                                    <div className="flex flex-row col-12 mb-2 md:col-3 lg:col-2 lg:mb-0 align-items-center"></div>
                                    <div className="flex flex-row col-12 mb-2 md:col-3 lg:col-5 lg:mb-0 align-items-center p-0 justify-content-end">
                                        <p style={{ fontSize: '0.8rem' }} className="flex align-items-center" >Procmart State: 
                                            {
                                                !isEditPMState ?
                                                    <>
                                                        <span className="font-bold ml-2">
                                                            {relatedPMState?.stateName} {relatedPMBillAddr?.gstinCode ? `- (${relatedPMBillAddr.gstinCode})` : ""}
                                                        </span>
                                                        {!isActivePIPunchExists && <i className="pi pi-pencil ml-1" style={{ fontSize: '0.6rem', cursor: "pointer" }} onClick={() => setIsEditPMState(true)}></i>}
                                                    </>
                                                :
                                                    <div className="ml-2 mt-0 p-0 flex flex-row align-items-center justify-content-center" style={{ float: 'right' }}>
                                                        <DropDownField name="pmStateId" options={PMStates} value={selectedPMState} optionLabel="stateNameWithGstinCode" optionValue="stateId" onChange={handlePMStateChange} />
                                                    </div>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="p-card my-2 py-2">
                                <div className="grid">
                                    <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0">
                                        <TextInputField name="sellerPINumber" disabled={checked || sellerPO?.isAllProcessed} labelText="PI Number" errorMessage={piPunchErrors?.sellerPINumber} placeholder="" value={sellerPO?.sellerPINumber} maxLength={16} onChange={(e) => handleInputChange(e)} />
                                    </div>
                                    <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0">
                                        <CalendarField name="sellerPIDate" disabled={checked || sellerPO?.isAllProcessed} minDate={minPIDate} maxDate={new Date()} labelText="PI Date" errorMessage={piPunchErrors?.sellerPIDate} placeholder="" value={sellerPO?.sellerPIDate} onChange={(e) => handleInputChange(e)} />
                                    </div>
                                    <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0">
                                        <TextInputField name="sellerPITotalAmount" disabled={checked || sellerPO?.isAllProcessed} labelText="PI Amount" errorMessage={piPunchErrors?.sellerPITotalAmount} placeholder="" keyfilter="num" value={numberConversion(sellerPO?.sellerPITotalAmount, numberLocale)} onChange={(e) => handleInputChange(e)} />
                                    </div>
                                    <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0">
                                        <TextInputField name="sellerPICalculatedTotalAmount" labelText="Total Amount" disabled placeholder="" value={numberConversion(sellerPO?.sellerPICalculatedTotalAmount, numberLocale)} keyfilter="num" onChange={(e) => handleInputChange(e)} />
                                    </div>
                                        <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0">
                                            <label className="text-xs mb-1">PI Document </label>
                                            {
                                                piPunchImageName ?
                                                    <div className="mt-2">
                                                        <div>
                                                            <li className="flex flex-wrap">
                                                                <a href={piPunchImageName.url} className="view-btn mr-3" style={{ textDecoration: "None" }} target="_blank">View</a>
                                                                <a style={{ cursor: "pointer" }} className="vendor-component-remove-btn" name="remove_invoice" onClick={(e) => removeSellerPIDocument(e)}>Remove</a>
                                                            </li>
                                                        </div>
                                                    </div>
                                                    :
                                                    <FileUpload className="upload-btn" mode="basic" name="sellerPIDocProof" accept=".jpg,.jpeg,.png,.pdf,.html" customUpload auto chooseLabel="Upload File" uploadHandler={files => fileUploadHandler(files, "SELLER_PI_DOCPROOF")} disabled={checked || sellerPO?.isAllProcessed} />
                                            }
                                        </div>
                                </div>
                            </div>
                            <div className="flex justify-content-between flex-wrap">
                                <div className="col-3 p-2">
                                    <div className="grid">
                                        <div className="flex flex-row col-12 mb-2 lg:mb-0">
                                            <Button className="small-btn w-6rem" label="RESET ALL" onClick={() => handleResetClick()} />
                                            <Button className="small-btn col-12 w-5rem ml-2" label="APPLY" onClick={() => handleApplyClick()} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-card p-2">
                                <div className="flex flex-wrap py-2 w-full">
                                    <div className="flex pl-2 header-style" style={{ color: "#6c757d" }}>
                                        <div className="mb-2" style={{ width: '2%' }}>
                                            <CheckboxField onChange={e => handleCheckBoxClick(e)} disabled={sellerPO?.isAllProcessed} checked={selectedSellerPOItemIds?.length === sellerPOItems?.length} />
                                        </div>
                                        <div className="mb-2 ml-1" style={{ width: '2%' }}>Sr</div>
                                        <div className="mb-2" style={{ width: '10%' }}>Product</div>
                                        <div className="mb-2 ml-2" style={{ width: '20%' }}>Specifications</div>
                                        <div className="mb-2" style={{ width: '5%' }}>Total Qty</div>
                                        <div className="mb-2 ml-2" style={{ width: '5%' }}>Ava. Qty</div>
                                        <div className="mb-2 ml-2" style={{ width: '5%' }}>TTL Rec.Qty</div>
                                        <div className="mb-2" style={{ width: '10%' }}>{pmCompanyConfig.GSTRateLabel}</div>
                                        {
                                            isHSNEntryAllowed ? 
                                            <div className="mb-2" style={{ width: '10%' }}>HSN Code</div>
                                            :
                                            null
                                        }
                                        <div className="mb-2 ml-1" style={{ width: '8%' }}>Input Qty</div>
                                        {/*<div className="mb-2 ml-2" style={{ width: '10%' }}>TDS</div>*/}
                                        <div className="mb-2" style={{ width: '8%' }}>Delivery Due</div>
                                    </div>
                                    <div className="w-full">
                                        {
                                            updatedSellerPOItems?.map((eachSellerPOItem, index) => {
                                                const relatedMaterialData = materialDetails?.find(eachMaterial => eachMaterial.materialId === eachSellerPOItem.materialId)
                                                const relatedMaterialBrand = materialBrands?.find(eachMaterialBrand => eachMaterialBrand?.brandId === relatedMaterialData?.brandId)
                                                let relatedPOPunchItem = poPunchItems?.find(eachPOPunchItem => eachPOPunchItem?.buyerPOItemId === eachSellerPOItem?.buyerPOItemId)

                                                let taxType = selectedPMBillAddr?.stateId === parseInt(sellerBillAddrDetails?.stateId) ? "CSGST" : "IGST"
                                                if (selectedPMBillAddr?.gstinCode && !["URP", "URD"].includes(selectedPMBillAddr?.gstinCode) && sellerBillAddrDetails?.gstinCode && !["URP", "URD"].includes(sellerBillAddrDetails?.gstinCode)) {
                                                    taxType = parseInt(selectedPMBillAddr?.gstinCode?.slice(0, 2)) === parseInt(sellerBillAddrDetails?.gstinCode?.slice(0, 2)) ? "CSGST" : "IGST"
                                                }
                                                
                                                let deliveryDueDate = getDateString(relatedPOPunchItem?.expectedDeliveryDate)
                                                let totalReceivedQty = 0

                                                let isGSTRateEditIconShown = true
                                                let isHSNCodeEditIconShown = true
                                                sellerPIPunchItems?.map(eachSellerPIPunchItem => {
                                                    if (eachSellerPIPunchItem.sellerPOItemId === eachSellerPOItem.sellerPOItemId && eachSellerPIPunchItem?.statusId === 1) {
                                                        totalReceivedQty = round(totalReceivedQty + eachSellerPIPunchItem.qty)
                                                        isGSTRateEditIconShown = false
                                                        isHSNCodeEditIconShown = false
                                                    }
                                                })

                                                let tdsSection = ""
                                                if (eachSellerPOItem?.tdsSection) {
                                                    tdsSection = eachSellerPOItem?.tdsSection
                                                }
                                                if (eachSellerPOItem?.tdsValue) {
                                                    tdsSection += ` | ${eachSellerPOItem?.tdsValue}%`
                                                }
                                                if (eachSellerPOItem?.tdsAmount) {
                                                    tdsSection += ` Rs. ${eachSellerPOItem?.tdsAmount}`
                                                }
                                            
                                                return (
                                                    <div className="flex pl-2 data-style" key={`sellerPOItem-${eachSellerPOItem.sellerPOItemId}`}>
                                                        <div className="py-2" style={{ width: '2%', alignSelf: "center" }}>
                                                            <CheckboxField 
                                                                onChange={() => handleSelectClick(eachSellerPOItem.sellerPOItemId)} 
                                                                disabled={sellerPO?.isAllProcessed || (![2,3,8,11,14,15,16,17,18].includes(eachSellerPOItem.followUpStatusId) && !sellerPO.expenseCategoryId)}
                                                                tooltip={(![2,3,8,11,14,15,16,17,18].includes(eachSellerPOItem.followUpStatusId) && !sellerPO.expenseCategoryId) && "Followup should be completed before inward can be done"} 
                                                                tooltipOptions={{ position: 'top', showOnDisabled: true }}
                                                                checked={selectedSellerPOItemIds.includes(eachSellerPOItem.sellerPOItemId)} />
                                                        </div>
                                                        <div className="py-2 ml-1" style={{ width: '2%', alignSelf: "center" }}>{index + 1}</div>
                                                        <div className="py-2" style={{ width: '10%', alignSelf: "center" }}>{eachSellerPOItem?.materialId} | {relatedMaterialBrand?.brandName && `${relatedMaterialBrand?.brandName} - `}{relatedMaterialData?.productName} {relatedMaterialData?.variantName && ` - ${relatedMaterialData?.variantName}`}</div>
                                                        <div className="py-2 ml-2" style={{ width: '20%', alignSelf: "center" }}>{relatedMaterialData?.productSpecification} - {getUOMStr(relatedMaterialData?.UOM, relatedMaterialData?.UOMValue)}</div>
                                                        <div className="py-2" style={{ width: '5%', alignSelf: "center" }}>{eachSellerPOItem.qty}</div>
                                                        <div className="py-2 ml-2" style={{ width: '5%', alignSelf: "center" }}>{round(eachSellerPOItem.qty - totalReceivedQty)}</div>
                                                        <div className="py-2 ml-2" style={{ width: '5%', alignSelf: "center" }}>{totalReceivedQty}</div>
                                                        {
                                                            eachSellerPOItem.isEditGSTRate ?
                                                                <div className="flex py-2" style={{ width: '10%', alignSelf: "center", alignItems: "center"}}>
                                                                    <DropDownField style={{ width: '110px'}} name="GSTRate" labelText='' value={eachSellerPOItem?.GSTRate} options={gstOptions} optionLabel="label" optionValue="GSTRate" keyfilter="num" onChange={(e) => handleInputGSTAndHSNChange(e, eachSellerPOItem.sellerPOItemId)} />
                                                                </div>
                                                                :
                                                                <div className="py-2" style={{ width: '10%', alignSelf: "center" }}>
                                                                    {`${taxType}(${eachSellerPOItem?.GSTRate})`}
                                                                    {
                                                                        isGSTRateEditIconShown ?
                                                                            <i className="pi pi-file-edit ml-1" onClick={(event) => handleEditGSTRateAndHSNCode(event, eachSellerPOItem.sellerPOItemId, "GSTRate")} style={{ fontSize: '0.6rem', cursor: "pointer" }}></i>
                                                                            :
                                                                            ""
                                                                    }
                                                                </div>
                                                        }
                                                        {
                                                            isHSNEntryAllowed ? 
                                                            (
                                                                eachSellerPOItem.isEditHSNCode ? 
                                                                    <div className="flex py-2" style={{ width: '10%', alignSelf: "center", alignItems: "center"}}>
                                                                        <TextInputField name="HSNCode" style={{ width: '80px'}} keyfilter={"pnum"} labelText='' value={eachSellerPOItem?.HSNCode} onChange={e => handleInputGSTAndHSNChange(e, parseFloat(eachSellerPOItem?.sellerPOItemId))} onBlur={(e) => handleHSNCodeBlur(e, eachSellerPOItem)}/>
                                                                    </div>
                                                                    :
                                                                    <>
                                                                        <div className={`py-2 compare-tooltip-${eachSellerPOItem.sellerPOItemId}`} style={{ width: '10%', alignSelf: "center" }}>
                                                                            {`${eachSellerPOItem?.HSNCode}`}
                                                                            {
                                                                                isHSNCodeEditIconShown ?
                                                                                    <i className="pi pi-pencil ml-1" onClick={(event) => handleEditGSTRateAndHSNCode(event, eachSellerPOItem.sellerPOItemId, "HSNCode")} style={{ fontSize: '0.6rem', cursor: "pointer" }}></i>
                                                                                    :
                                                                                    <Tooltip target={`.compare-tooltip-${eachSellerPOItem.sellerPOItemId}`} position="right">
                                                                                        <p>HSNCode cannot be edited as the first PI Punch has been done already with this material.</p>
                                                                                    </Tooltip>
                                                                            }
                                                                        </div>
                                                                    </>
                                                            )
                                                            :
                                                            null
                                                        }
                                                        <div className="py-2 ml-1" style={{ width: '8%', alignSelf: "center" }}>
                                                            <TextInputField 
                                                                name="inputQty" 
                                                                labelText="" 
                                                                placeholder="" 
                                                                style={{ width: "100%" }} 
                                                                disabled={eachSellerPOItem?.qty === totalReceivedQty || isCashPayment || eachSellerPOItem?.statusId === 6 || (![2,3,8,11,14,15,16,17,18].includes(eachSellerPOItem.followUpStatusId) && !sellerPO.expenseCategoryId)} 
                                                                // tooltip={isCashPayment && "Total Qty Can be Punched as it has CASH Payment Mode."}
                                                                tooltip={
                                                                    [
                                                                      isCashPayment && "Total Qty Can be Punched as it has CASH Payment Mode.",
                                                                      (![2,3,8,11,14,15,16,17,18].includes(eachSellerPOItem.followUpStatusId) && !sellerPO.expenseCategoryId) && "Followup should be completed before inward can be done"
                                                                    ]
                                                                      .filter(Boolean)
                                                                      .join("\n")
                                                                }
                                                                tooltipOptions={{ position: 'right', showOnDisabled: true }}  
                                                                value={eachSellerPOItem?.inputQty} keyfilter="num" 
                                                                onChange={(e) => handleInputQtyChange(e, eachSellerPOItem.sellerPOItemId, round(eachSellerPOItem.qty - totalReceivedQty))}
                                                            />
                                                        </div>
                                                        {/*<div className="py-2 ml-2" style={{ width: '10%', alignSelf: "center"}}>{tdsSection}</div>*/}
                                                        <div className="py-2" style={{ width: '8%', alignSelf: "center"}}>{deliveryDueDate}</div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="text-center font-bold mb-2">Logistics </div>
                            <div className="flex flex-column justify-content-end">
                                <div className="flex flex-row justify-content-center">
                                    <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0">
                                        <TextInputField name="sellerPILogisticsWithTax" keyfilter={"pnum"} disabled={sellerPO?.logisticsAmountLeft === 0} labelText='Amount' value={sellerPO?.sellerPILogisticsWithTax} onChange={e => handleInputChange(e, parseFloat(sellerPO?.logisticsAmountLeft))} />
                                    </div>
                                    {
                                        isHSNEntryAllowed ?
                                        <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0">
                                            <TextInputField name="logisticsHSNCode" labelText='Logistics HSN' disabled value={sellerPO?.logisticsHSNCode} />
                                        </div>
                                        :
                                        null
                                    }
                                    <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0">
                                        <TextInputField name="logisticsTDS" disabled labelText='Logistics TDS' value={logisticsTDSSection} />
                                    </div>
                                </div>
                            </div>
                            {
                                (!isActivePIPunchExists && sellerCompanyBillAddrs.length > 0)
                                &&
                                <div className="mt-1">
                                    <p className="font-semibold text-xs mb-2 mt-">Seller Billing Addresses<span style={{ color: 'red', marginLeft: '1px' }}>*</span></p>
                                    {
                                        sellerCompanyBillAddrs.length === 0 ?
                                            <p className='mb-2 mt-0 ml-2 font-semibold billing-address-msg text-700 text-red-500'>Billing addressses are not available. Please contact tech support</p>
                                            :
                                            <BillingAddressCards billingAddresses={sellerCompanyBillAddrs} selectedAddressId={sellerBillAddrDetails?.billAddrId} handleBillingAddress={handleSellerBillAddr} />
                                    }
                                </div>
                            }
                            <div className="font-bold">
                                ACKNOWLEDGEMENT:
                            </div>
                            <div className="mt-2">
                                <div className="flex flex-row col-12 mb-2 lg:col-12 lg:mb-0">
                                    <Checkbox onChange={e => setDeclaration(e.checked)} checked={declaration} style={{ textAlign: "center" }} disabled={sellerPO?.isAllProcessed}></Checkbox>
                                    <label style={{ marginBottom: "5px", fontSize: "13px", marginLeft: "8px" }} >I hereby declare that the information given in this application is true and correct to the best of my knowledge and belief. In case any information given in this application proves to be false or incorrect, I shall be responsible for the consequences.</label>
                                </div>
                            </div>
                            <div className="flex justify-content-center mt-2">
                                <Button className="" label="PI PUNCH" disabled={piPunchDisableCond} onClick={handlePIPunchClick} permissions={[19, 20]} applyThrottle={true} /> {/*disabled={!isInvoiceEnableForPMBranch || sellerPO?.isAllProcessed || sellerPO?.statusId === 6} */}
                            </div>
                        </TabPanel>
                        <TabPanel header="PI History" className="pi-details">
                            <PIReceivedProductDetails
                                materialBrands={materialBrands}
                                fileUploadHandler={fileUploadHandler}
                                uploadSellerPIDocument={uploadSellerPIDocument}
                                removeSellerPIDocument={removeSellerPIDocument}
                                sellerPO={sellerPO}
                                sellerPOItems={sellerPOItems}
                                sellerPIPunch={sellerPIPunch}
                                setSellerPIPunch={setSellerPIPunch}
                                sellerPIPunchItems={sellerPIPunchItems}
                                sellerGRNQCPunch={sellerGRNQCPunch}
                                PIPunchBookingLogs={PIPunchBookingLogs}
                                materialDetails={materialDetails}
                                handlePIDoc={handlePIDoc}
                                handleEditClick={handleEditClick}
                                handleSaveClick={handleSaveClick}
                                handleSellerPIChange={handleSellerPIChange}
                                handleDeleteSellerPIPunch={handleDeleteSellerPIPunch}
                                PIPunchCreatedUsers={PIPunchCreatedUsers}
                                adjustmentNotes={adjustmentNotes}
                                adjustmentNoteItems={adjustmentNoteItems}
                                setIsLoaderVisible={setIsLoaderVisible}
                                setSellerGRNQCPunch={setSellerGRNQCPunch}
                                piPunchErrors={piPunchErrors}
                                piPunchImageName={piPunchImageName}
                                approvalInstances={approvalInstances}
                                processLineItems={processLineItems}
                                sellerPIPunchTickets={sellerPIPunchTickets}
                                isLoaderVisible={isLoaderVisible}
                                ticketSubCategoies={ticketSubCategoies}
                                approvals={approvals}
                            />
                        </TabPanel>
                        {
                            sellerPIPunch?.length > 0 &&
                            <TabPanel header="GRN & QC" className="pi-details">
                                <GRN selectedSellerPO={{ data: data }} sellerBillAddrDetails={sellerBillAddrDetails} isDisplayVisible={false} handleSellerGRNQCPunchRefresh={handleSellerGRNQCPunchRefresh} />
                            </TabPanel>
                        }
                    </TabView>
                }
            </div>
            <Dialog header={"PI PUNCH CONFIRMATION"} className="" visible={isPIPunchConfirmModalVisible} style={{ width: piPunchImageName ? '70vw' : '35vw', height: piPunchImageName ? '85vh' : '' }} onHide={() => setIsPIPunchConfirmModalVisible(false)} >
                <Loading visible={isLoaderVisible} />
                <PIPunchConfirmDialog
                    handlePIPunchConfirmModal={handlePIPunchConfirmModal}
                    PIPunchSubmitData ={PIPunchSubmitData}
                    selectedPMBillAddr={selectedPMBillAddr}
                    sellerBillAddrDetails={sellerBillAddrDetails}
                    sellerPO={sellerPO}
                    piPunchImageName={piPunchImageName}
                />
            </Dialog>
        </>
        // </Dialog>
    )
}

export default PIPunch;